import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource } from 'utility-ts-orm';
import { PathTask } from './../builders/path_task_builder';

angular
  .module('data-ng-todos')
  .factory(
    'getAdaptivePathChangesCommand',
    function getAdaptivePathChangesCommandDefinition(
      pathTasksVisibilityModel: any,
      ngPathTaskDatastore: IDatasource<PathTask>,
      defineCommand: IDefineCommand
    ) {
      return defineCommand('getAdaptivePathChangesCommand', function getAdaptivePathChangesCommand(deferred) {
        let totalNoOfChanges = 0;
        pathTasksVisibilityModel.hasPathVisibilityChanges = false;
        let otherChangesFromServerNotOnCurrentPath;

        const findTaskByEventId = (taskStatusObj: PathTask) => {
          const tasks = ngPathTaskDatastore.query((tsk) => {
            return tsk.event === taskStatusObj.event && tsk.repeated_by === taskStatusObj.repeated_by;
          });
          return tasks.length === 0 ? undefined : tasks[0];
        };

        const getTaskChanges = () => {
          const tasksWithDependency = _4.compact(
            _4.map(pathTasksVisibilityModel.task, (task: PathTask) => {
              return findTaskByEventId(task);
            })
          );
          const visibilityChanges = _4.reduce(
            pathTasksVisibilityModel.task,
            (sum: number, taskStatusObj: PathTask) => {
              const currentTaskWithDep = _4.find(tasksWithDependency, (tsk: PathTask) => {
                return tsk.event === taskStatusObj.event && tsk.repeated_by === taskStatusObj.repeated_by;
              });

              let changeValue = 0;
              if (currentTaskWithDep && !_4.isEqual(taskStatusObj.show, currentTaskWithDep.show)) {
                changeValue = 1;
              }
              return changeValue + sum;
            },
            0
          );

          const pathVisibilityChanges = _4.size(pathTasksVisibilityModel.task);
          otherChangesFromServerNotOnCurrentPath = pathVisibilityChanges - _4.size(tasksWithDependency);
          return visibilityChanges + otherChangesFromServerNotOnCurrentPath;
        };

        totalNoOfChanges = _4.size(pathTasksVisibilityModel.task) > 0 ? getTaskChanges() : 0;

        deferred.resolve({
          adaptivePathChanges: totalNoOfChanges,
          changesThatNeedServerFetch: otherChangesFromServerNotOnCurrentPath
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/get_adpative_path_changes_command.ts